import { render, staticRenderFns } from "./CompanyBoard.vue?vue&type=template&id=6d0df334"
import script from "./CompanyBoard.vue?vue&type=script&lang=js"
export * from "./CompanyBoard.vue?vue&type=script&lang=js"
import style0 from "./CompanyBoard.vue?vue&type=style&index=0&id=6d0df334&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports